// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"65":"9e029ca5","72":"55a33cef","377":"4cec4498"}[chunkId] + ".js";
};